import { atom } from 'jotai';
import { BranchInformation } from '../interfaces/clientConfiguration';

export const branchInformationAtom = atom<BranchInformation | null>(null);
